import React, { Suspense } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import RouteBreadcrumb from './components/RouteBreadcrumb';
import Footer from './components/Footer';
import FloatingChatroomAccess from './components/FloatingChatroomAccess';
import FloatingChatroom from './components/FloatingChatroom';
import FloatingCareroom from './components/FloatingCareroom';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import useMemberSessionSync from '@/shared/hooks/useMemberSessionSync';
import { useMemberContext } from '@/shared/contexts/memberContext';
import '@/shared/helpers/axios';

const MobileNavbar = React.lazy(() => import('./components/MobileNavbar'));
const ProfessionalList = React.lazy(() => import('./pages/ProfessionalList'));
const ProfessionalDetail = React.lazy(() => import('./pages/ProfessionalDetail'));
const ProfessionalArea = React.lazy(() => import('./pages/ProfessionalArea'));
const ProfessionalServiceDetail = React.lazy(() => import('./pages/ProfessionalServiceDetail'));
const SurveiRequestCreator = React.lazy(() => import('./pages/SurveiRequestCreator'));
const DirectOrderCreator = React.lazy(() => import('./pages/DirectOrderCreator'));

function App() {
    const { isSync } = useMemberSessionSync();
    const { member } = useMemberContext();
    const isLogin = !!localStorage.getItem('accessToken') || !!member;

    const renderTopNavigation = () => {
        return isMobile ? (
            <Suspense fallback={<div>Loading...</div>}>
                <MobileNavbar />
            </Suspense>
        ) : (
            <Navbar />
        );
    };

    return (
        <div>
            {!isSync ? (
                <div className="App">
                    <Router>
                        {renderTopNavigation()}
                        {!isMobile && <RouteBreadcrumb />}
                        <Switch>
                            <Route exact path="/">
                                <Redirect to="/p/list" />
                            </Route>
                            <Route path="/p/list">
                                <Suspense fallback={<div>Loading...</div>}>
                                    <ProfessionalList />
                                </Suspense>
                            </Route>
                            <Route path="/p/detail/:id">
                                <Suspense fallback={<div>Loading...</div>}>
                                    <ProfessionalDetail />
                                </Suspense>
                            </Route>
                            <Route path="/p/service-detail/:id">
                                <Suspense fallback={<div>Loading...</div>}>
                                    <ProfessionalServiceDetail />
                                </Suspense>
                            </Route>
                            <Route path="/p/area">
                                <Suspense fallback={<div>Loading...</div>}>
                                    <ProfessionalArea />
                                </Suspense>
                            </Route>
                            <Route path="/p/survey-request">
                                <Suspense fallback={<div>Loading...</div>}>
                                    <SurveiRequestCreator />
                                </Suspense>
                            </Route>
                            <Route path="/p/direct-order/:serviceId/:quantity/:serviceVariantId/:serviceVariantName/:serviceVariantPrice">
                                <Suspense fallback={<div>Loading...</div>}>
                                    <DirectOrderCreator />
                                </Suspense>
                            </Route>
                            <Route path="/p/">
                                <Suspense fallback={<div>Loading...</div>}>
                                    <ProfessionalList />
                                </Suspense>
                            </Route>
                        </Switch>
                        <Footer />
                        {isLogin && <FloatingChatroomAccess />}
                        {isLogin && <FloatingChatroom />}
                        {isLogin && <FloatingCareroom />}
                    </Router>
                </div>
            ) : (
                <div>Sync..</div>
            )}
        </div>
    );
}

export default App;
